import useTestId from '@ori/testid-generator';
import bemCssModules from 'bem-css-modules';
import { observer } from 'mobx-react-lite';
import type { VFC } from 'react';
import { FormattedMessage } from 'react-intl';

import SearchHeaderTitleModuleCss from './SearchHeaderTitle.module.css';
import { LocalizedText } from '~/components/LocalizedText/LocalizedText';
import { localizationFallbackItems, LocalizationItem } from '~/constants';
import type { SearchResultStore } from '~/stores';
import { useSearchResultStore } from '~/stores';

const block = bemCssModules(SearchHeaderTitleModuleCss);

interface SearchHeaderTitleProps {
  isRootPath: boolean;
}

export const SearchHeaderTitle: VFC<SearchHeaderTitleProps> = observer(({ isRootPath }) => {
  const { searchResult, searchQuery }: SearchResultStore = useSearchResultStore();
  const { getTestId } = useTestId();

  if (isRootPath) {
    return (
      <h1
        className={block({ 'is-default': !searchQuery })}
        data-testid={getTestId('top-banner-title')}
      >
        <LocalizedText localizationItem={LocalizationItem.HiHowCanWeHelp} />
      </h1>
    );
  }

  return (
    <h1
      className={block({ 'is-default': !searchQuery })}
      data-testid={getTestId('top-banner-title')}
    >
      <FormattedMessage
        id={LocalizationItem.NResultsForQuery}
        defaultMessage={localizationFallbackItems[LocalizationItem.NResultsForQuery]}
        values={{ count: searchResult.TotalCount, query: searchQuery }}
      />
    </h1>
  );
});
